define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/action/Controller",
    "csi/comm/PostRequest",
    "csi/locale",
    "csi/store/Values",
    "csi/xml",
    "csi/widget/MessageDialog"
], function(declare,lang,Controller,PostRequest,locale,ValuesStore,xml,MessageDialog) {

return declare(Controller, {

        confirmed: false,

        onConfirm: function(/*String*/key) {
            // summary: if configured to confirm action, then start now that confirmed
            if (key == MessageDialog.BUTTON_DELETE) {
                this.confirmed = true;
                this.process(true);
            } else {
                this.postProcess();
            }
        },

        hasToConfirmAction: function() {
            // do not display the confirmation dialog before the form
            // confirmedAction is called manually from process method
            return false;
        },

        _preAction: function() {
            // summary: add any requests necessary to fetch data before executing action
            this._sectionsStore = new ValuesStore({
                bBlanks: true,
                typeNode: "MaterialPlanPlacement",
                requestParameters: {
                    "Qry.Value.Locale": locale.getLocale(),
                    "Qry.Limit.Path": xml.getUrlPath(this.getParentURL(), xml.path("Items")),
                    "Qry.Value.Path": "Child:DSSection",
                    "Qry.Value.Node": "Name"
                }
            });

            return this._sectionsStore.query();
        },

        process: function() {
            // summary: issue request so as to be able to receive return value
            var req = this.m_action.m_request;
            var fd = this.m_formData;
            var m_id = this.m_action.m_id;

            this.setProgress();

            if(m_id=="MassDelete" && !this.confirmed ) {
                this.confirmAction({});
            }
            else{

                const themeURL = (this.getParent() && this.getParent().$Type == "Theme") ? this.m_urlParent : this.m_urlNode;

                const postReq = new PostRequest(req.m_module, req.m_operation)
                    .addParameter("ParentURL", themeURL)
                    .addParameter("Styles",fd.getFieldValue("Styles"))
                    .addParameter("ThemePlacements", fd.getFieldValue("ThemePlacements"))
                    .addParameter("ColorColorways",fd.getFieldValue("ColorColorways"))
                    .addParameter("BOMSubtype", fd.getFieldValue("BOMSubtype"))
                    .addParameter("IncludeBlankAttributes", fd.getFieldValue("IncludeBlankAttributes"))
                    .addParameter("Option", m_id);

                this.waitForPublish(postReq.post(), true);
            }
        }
    });
});